"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleListFilter = void 0;
class ArticleListFilter {
    constructor(data) {
        this.limit = 50;
        this.skip = 0;
        this.orderBy = 'id';
        this.order = 'ASC';
        this.term = null;
        this.type = null;
        this.published = null;
        this.archived = null;
        this.specialties = [];
        this.professions = [];
        this.countries = [];
        this.areas = [];
        this.roles = [];
        this.isPinned = null;
        if (data) {
            this.hydrate(data);
        }
    }
    hydrate(data) {
        for (const prop in data) {
            if (Object.prototype.hasOwnProperty.call(this, prop) && Object.prototype.hasOwnProperty.call(data, prop)) {
                this[prop] = data[prop];
            }
        }
    }
}
exports.ArticleListFilter = ArticleListFilter;
//# sourceMappingURL=ArticleListFilter.js.map